var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "url(#paint0_linear_2173_20276)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 58,
    height: 80,
    rx: 4.85714,
    stroke: "white",
    strokeOpacity: 0.3,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4613 24.978V22.382L18.1053 16.486C18.604 16.046 18.956 15.6317 19.1613 15.243C19.3667 14.8543 19.4693 14.4913 19.4693 14.154C19.4693 13.67 19.3703 13.241 19.1723 12.867C18.9743 12.4857 18.6957 12.1887 18.3363 11.976C17.977 11.756 17.5553 11.646 17.0713 11.646C16.5653 11.646 16.118 11.7633 15.7293 11.998C15.348 12.2253 15.051 12.5297 14.8383 12.911C14.6257 13.285 14.5267 13.692 14.5413 14.132H11.4613C11.4613 13.0467 11.6997 12.108 12.1763 11.316C12.653 10.524 13.3167 9.91167 14.1673 9.479C15.018 9.04633 16.008 8.83 17.1373 8.83C18.1713 8.83 19.0953 9.05733 19.9093 9.512C20.7307 9.95933 21.376 10.5863 21.8453 11.393C22.3147 12.1997 22.5493 13.1347 22.5493 14.198C22.5493 14.9827 22.4393 15.6353 22.2193 16.156C21.9993 16.6693 21.673 17.146 21.2403 17.586C20.8077 18.0187 20.276 18.51 19.6453 19.06L15.3553 22.822L15.1133 22.162H22.5493V24.978H11.4613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 39.7305C24.5 35.8761 18.9316 33.8868 17.0522 30.3122L16.9826 30.25L16.9478 30.3122C15.0684 33.8868 9.5 35.8761 9.5 39.7305C9.5 42.9631 14.268 44.2065 16.5998 41.5022C16.6346 41.3779 16.5998 42.3726 16.4258 42.9321C15.8689 44.5795 13.8503 47.004 12.8759 47.75C14.2332 46.7242 19.6972 46.7242 21.0545 47.75C20.08 47.004 18.1659 44.6727 17.5046 42.9321C17.3654 42.4347 17.2958 41.9685 17.261 41.4711C19.558 44.393 24.5 43.0253 24.5 39.7305Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 60.3148C50.5 53.377 40.4768 49.7962 37.094 43.3619L36.9687 43.25L36.906 43.3619C33.5232 49.7962 23.5 53.377 23.5 60.3148C23.5 66.1337 32.0824 68.3717 36.2796 63.504C36.3422 63.2802 36.2796 65.0706 35.9664 66.0777C34.964 69.0431 31.3306 73.4072 29.5766 74.75C32.0197 72.9036 41.855 72.9036 44.2981 74.75C42.5441 73.4072 39.0986 69.2109 37.9084 66.0777C37.6578 65.1825 37.5325 64.3432 37.4698 63.448C41.6044 68.7074 50.5 66.2456 50.5 60.3148Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2173_20276",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2S);
export default __webpack_public_path__ + "static/media/2s.507a7331fa48868c74439f87dff3fdf6.svg";
export { ForwardRef as ReactComponent };